import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import GroupeSelect from './GroupeSelect';
import { fetchGroupes } from 'store/groupe/groupeActions';

class GroupeSelectContainer extends React.Component {
    componentDidMount() {
        this.props.fetchGroupes();
    }

    render() {
        const { groupes, value, isLoading, onChange, all, excluded, isRequired, error, disabled, label, size } = this.props;

        return (
            <GroupeSelect
                groupes={groupes}
                value={value}
                isLoading={isLoading}
                onChange={onChange}
                all={all}
                excluded={excluded}
                error={error}
                isRequired={isRequired}
                disabled={disabled ? disabled === true : false}
                label={label}
                size={size}
            />
        );
    }
}

const mapStateToProps = state => ({
    groupes: state.groupe.groupes.items,
    isLoading: state.groupe.groupes.isLoading
});

const mapDispatchToProps = dispatch => ({
    fetchGroupes: () => dispatch(fetchGroupes())
});

GroupeSelectContainer.propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    all: PropTypes.bool.isRequired,
    excluded: PropTypes.number,
    isRequired: PropTypes.bool.isRequired,
    error: PropTypes.object,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    size: PropTypes.string
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupeSelectContainer);